import React from 'react';
import CardsAccepted from '../CardsAccepted';
// import { sizes } from '../../theme';
import PaymentSelector from '../PaymentSelector';
import UnitDetailContent from '../UnitDetailsContent';

const propTypes = {
};

const defaultProps = {
};

const Step3 = () => (
    <>
      <UnitDetailContent showOn="mobile" />
      <PaymentSelector />
      <CardsAccepted />
    </>
);
Step3.propTypes = propTypes;
Step3.defaultProps = defaultProps;

export default Step3;
